import React, { Component } from 'react';
export default class ImplicitCallback extends Component {
    render() {
        return (
            <div className="unauthorized-layout">
                <div className="loading-indicator">
                    <h2 className="loading-indicator-text">
                        <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                        <span>Fetching user information</span>
                    </h2>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ImplicitCallback/index.js